<template>
<div class="convention-hall page" style="width: 100%; padding-bottom: 4.33333rem; background: url(/img/home/g.f7e76bcc.png) repeat top / 100% auto;">
  <van-nav-bar
      class="nav-bar"
      :title="$t('foorter.video')"
  />
  <div class="data" style="width: 100%;">
	<div class="items" @click="$router.push({path:'/Video'});">
	<div style="display: flex;align-items: center;">
		<img src="/img/footer/ys1.png" style="width: 30px;height:30px"><span style="color: #000;margin-left: .33333rem;font-size: .93333rem;"> {{$t("foorter.top16")}}</span>
	</div>
	<div style="display: flex;align-items: center;">
		<span style="color: #666;font-size: .8rem;margin-right: .33333rem;">{{$t("foorter.top17")}}</span>
		<div style="position: relative;display: inline-block;">
			<div style="margin-left: .33333rem;color: #999;font-size: 32px;"><img src="/img/home/cs.png" style="display: block;width: 32px;height: 32px;-o-object-fit: contain;object-fit: contain;"/></div>
			<div style="position:absolute;width: 8px;min-width: 0;height: 8px;background:#ee0a24;border-radius: 100%;border: none;padding: 0;border: none;top: 0px;left: 34px;"></div>
		</div><van-icon name="arrow" style="margin-left: 5px;"/>
	</div>
	</div><div class="items" @click="$router.push({path:'/Choose'});">
	<div style="display: flex;align-items: center;">
		<img src="/img/footer/fl1.png" style="width: 30px;height:30px"><span style=";color: #000;margin-left: .33333rem;font-size: .93333rem;"> {{$t("foorter.video")}}</span>
	</div>
	<div style="display: flex;align-items: center;">
		<span style="color: #666;font-size: .8rem;margin-right: .33333rem;">{{$t("foorter.top18")}}:232***</span>
		<div style="position: relative;display: inline-block;">
			<div style="margin-left: .33333rem;color: #999;font-size: 32px;"><img src="/img/home/cs.png" style="display: block;width: 32px;height: 32px;-o-object-fit: contain;object-fit: contain;"/></div>
			<div style="position:absolute;width: 8px;min-width: 0;height: 8px;background:#ee0a24;border-radius: 100%;border: none;padding: 0;border: none;top: 0px;left: 34px;"></div>
		</div><van-icon name="arrow" style="margin-left: 5px;"/>
	</div>
	</div>
	
  </div>
<!--<div style="box-sizing: border-box;width: 100%;"><div style="width: 92%;margin: 0 auto;padding-bottom: 0px;"><ul class="ddd" style="width: 100%;display: flex;flex-wrap: wrap;justify-content: space-between;align-items: flex-start;">
<li style="background: url(/img/home/1.png) no-repeat 50% / 100%;"  @click="$router.push({path:'/Booking'});">
<div class="ddd1" style="border-radius:5px;padding:0 5px;;align-items: center;line-height: 32px;background: repeating-linear-gradient(-60deg, rgb(248, 92, 154), rgb(246, 74, 142), rgb(248, 92, 154), rgb(246, 74, 142), rgb(248, 92, 154), rgb(246, 74, 142), rgb(248, 92, 154), rgb(246, 74, 142))">
	<img src="/img/home/qy.png" style="display: block;width: 16px;height: 16px;-o-object-fit: contain;object-fit: contain;">{{$t("auth.top44")}}
</div>
<p style="font-size: .93333rem;font-weight: 600;color: #3d4651;text-align: left;margin-top: 1.66667rem;margin-left: 1.66667rem;">{{$t("auth.top44")}}</p>

</li>
</ul>
</div>
</div>-->

  <div style="box-sizing: border-box;width: 100%;"><div style="width: 92%;margin: 0 auto;padding-bottom: 4rem;"><ul class="ddd ddd2" style="width: 100%;display: flex;flex-wrap: wrap;justify-content: space-between;align-items: flex-start;">
  <li  @click="toLottery(v.key,v.id)" v-for="(v,key) in gameitem" :key="key">
	<div class="ddd1" style="align-items: center;line-height: 32px;">
		<img src="/img/home/qy.png" style="display: block;width: 16px;height: 16px;-o-object-fit: contain;object-fit: contain;">{{$t("foorter.top19")}}
	</div>
	<p v-if="lang=='zh'" style="font-size: .93333rem;font-weight: 600;color: #3d4651;text-align: left;margin-top: 1.66667rem;margin-left: 1.66667rem;">{{v.name}}</p>
	<p v-if="lang=='en'" style="font-size: .93333rem;font-weight: 600;color: #3d4651;text-align: left;margin-top: 1.66667rem;margin-left: 1.66667rem;">{{v.name_es}}</p>
	<p v-if="lang=='ja'" style="font-size: .93333rem;font-weight: 600;color: #3d4651;text-align: left;margin-top: 1.66667rem;margin-left: 1.66667rem;">{{v.name_ja}}</p>
	<p v-if="lang=='kr'" style="font-size: .93333rem;font-weight: 600;color: #3d4651;text-align: left;margin-top: 1.66667rem;margin-left: 1.66667rem;">{{v.name_kr}}</p>
  </li>
  </ul>
  </div>
  </div>


  <div class="convention-item" style="display: none;">
    <div class="left">
      <van-sidebar @change="onChange" v-model="activeKey">
        <van-sidebar-item :title="$t('index.all')" />
        <van-sidebar-item v-for="(v,key) in lotteryitem" :key="key" :title="v.name" />
      </van-sidebar>
    </div>
    <div class="right">
      <van-pull-refresh :border="false" class="list-wrapper" v-model="isLoading" @refresh="onRefresh">
        <van-grid :column-num="2">
          <van-grid-item @click="toLottery(v.key,v.id)" v-for="(v,key) in gameitem" :key="key">
            <van-image class="game_item_img" :src="v.ico">
              <template v-slot:loading>
                <van-loading type="circular"/>
              </template>
            </van-image>
            <span>{{v.name}}</span>
            <span>{{v.desc}}</span>
          </van-grid-item>
        </van-grid>
      </van-pull-refresh>
    </div>
  </div> <div style="padding-bottom: 35px;"></div>
</div>

</template>

<script>
import { Toast } from 'vant';
export default {
  data() {
    return {
      gameitem: [{},{},{},{}],
      lotteryitem: [{},{},{},{}],
      isLoading: false,lang:localStorage.getItem("lang") || "ja",
      activeKey: 0,
    };
  },
  methods: {
    onRefresh() {
      setTimeout(() => {
        Toast(this.$t("reservation.refresh"));
        this.isLoading = false;
      }, 500);
    },
    toLottery(key,id){
      if(!localStorage.getItem('token')){
        this.$router.push({path:'/Login'})
      }else {
        this.$router.push({path:'/Lottery?key='+key+"&id="+id})
      }
    },
    getGameItem(){
      this.$http({
        method: 'get',
        url: 'lottery_list'
      }).then(res=>{
        this.gameitem = res.data;
      })
    },
    onChange(index) {
      this.$http({
        method: 'get',
        data:{class:index},
        url: 'lottery_list'
      }).then(res=>{
        this.gameitem = res.data;
      })
    },
    getLotteryItem(){
      this.$http({
        method: 'get',
        url: 'lottery_class'
      }).then(res=>{
        this.lotteryitem = res.data;
      })
    }
  },
  created() {
    this.getGameItem();//获取首页游戏列表
    this.getLotteryItem();
  }
};
</script>

<style lang='less' scoped>
.page{
  position: absolute!important;
  top: 0;
  left: 0;
  right: 0;
  background-color: #f2f2f5;
}
.nav-bar{
  background:unset;
  height: 100px;color:#000;
}
.data .items{
	width: 92%;
	height: 4rem;
	background: #fff;
	margin: 0 auto 1rem;
	display: flex;
	justify-content: space-between;
	align-items: center;
	border-radius: .33333rem;
	padding: 0 .66667rem;
	box-shadow: 0 .13333rem .66667rem rgba(250, 26, 67, .17);
}
.van-nav-bar {
  line-height: 50px;
}.ddd li{
	margin-top: .53333rem;
	width: 100%;
	height: 9rem;
	margin: 0 0 .66667rem;
	border-radius: .66667rem;
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	align-items: flex-start;
}.ddd1{
	display: flex;
	justify-content: center;
	align-items: center;
	color: #fff;
	font-size: .73333rem;
	padding-left: 0;
}.ddd2 li:nth-child(1n) {
    background: url(/img/home/g1.png) no-repeat 50% / 100%;
}.ddd2 li:nth-child(2n) {
    background: url(/img/home/g2.png) no-repeat 50% / 100%;
}::v-deep .van-nav-bar__title {
  max-width: 60%;
  margin: 0 auto;
  color: #000;
  font-size: 35px;
}
::v-deep .van-nav-bar__content {
  height: 100px;
}
.van-sidebar {
  width: 180px;
}
.van-sidebar-item--select::before {
  left: 10px;
  height: 44%;
  background-color: #7e5678;
  border-radius: 5px;
  width: 10px;
}

.van-sidebar-item--select {
  color: #7e5678;
  font-size: 35px;
  text-align: center;
}
/deep/ .van-sidebar-item__text{
  width: 140px;
  margin-left: -25px;
}
.van-sidebar-item{
  font-size: 30px;
  text-align: center;
  padding: 50px;
  background-color: #ffffff;
}
.van-sidebar-item--select, .van-sidebar-item--select:active {
  background-color: #f2f2f5;;
}
.convention-item{
  display: flex;
  align-items: center;
  height: calc(100% - 15px);
}
.convention-hall{
  display: flex;
  flex-direction: column;
  bottom: 20px;
  background: #f2f2f5;
}
.convention-item .left{
  height: 100%;
  background-color: #fff;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}
.convention-item .right{
  height: 100%;
  flex: 1;
  background-color: #f2f2f5;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}
.convention-item .right .list-wrapper{
  padding: 20px 20px;
  min-height: 800px;
}
.convention-item .right .list-wrapper .game_item_img{
  width: 200px;
  height: 200px;
}
.convention-item .right .list-wrapper span{
  margin-top: 10px;
  font-size: 30px;
  color: #000;
}
.convention-item .right .list-wrapper span:last-child{
  margin-top: 10px;
  font-size: 24px;
  color: #000;
}
.van-grid-item {
  padding: 10px;

}
::v-deep .van-grid-item__content--center {
  border-radius: 15px;
}
::v-deep .van-image__img{
  border-radius: 40px;
}
::v-deep .van-pull-refresh__track .van-pull-refresh__head *{
  color: #000000;
  font-size: 35px;
}

</style>
